import _ from 'lodash';
import { IGlobalState } from '~reducer';

export function errorSelector(state: IGlobalState): string {
    return state.error.error;
}
